import classNames from 'classnames';

interface ISectionTitleFormProps {
  title: string;
  className?: string;
}

const SectionTitleForm = ({ title, className }: ISectionTitleFormProps) => {
  return (
    <div
      className={classNames(
        'border-b-2 border-primary-700 bg-primary-50 p-[12px] text-primary-700 text-[18px] leading-[22px] font-semibold',
        className
      )}
    >
      {title}
    </div>
  );
};

export default SectionTitleForm;
